import { useTheme } from "@mui/material/styles";

import useNav from "core/hooks/useNav";
import usePageShow from "core/hooks/usePageShow";
import useToggle from "core/hooks/useToggle";

import Box from "ui/atom/Box";
import Actions from "ui/base/Actions";
import Page from "ui/Page";

import { useUnlock } from "areas/unlock/fabric";
import Wallet from "areas/unlock/ui/Wallet";
import Info from "areas/unlock/ui/Info";


export default function Unlock() {
	const unlock = useUnlock();
	const theme = useTheme();
	const nav = useNav();
	const [loading, toggle, setLoading] = useToggle();
	usePageShow(() => setLoading(false));

	const style = {
		page: {
			justifyContent: { xs: "flex-start", sm: "center" },
			gap: 2.5,
			p: { xs: theme.spacing(0.75, 2), sm: theme.spacing(2.5, 2) }
		},
		body: { gap: 4, mb: 2 },
		content: { width: "100%", alignItems: "center" },
		actions: { maxWidth: "270px", width: "100%", m: "0 auto", gap: 2, alignItems: "center" }
	};

	const click = () => {
		toggle();
		unlock.mutation.mutate();
	};

	const actions = [
		{ label: unlock.copy.button, variant: "contained", color: "tertiary", onClick: click, loading: loading, disabled: unlock.block, hide: unlock.error },
		{ label: "Back", variant: "outlined", onClick: nav.back, disabled: (unlock.isLoading || unlock.mutation.isPending || loading), size: "small", sx: { width: "100px" } }
	];

	return (
		<Page maxWidth="dark" sx={style.page}>
			<Page.Header>
				{!unlock.isError && <Wallet />}
			</Page.Header>
			<Page.Body sx={style.body}>
				<Box.Column gap={2.5} sx={style.content}>
					<Info title={unlock.copy.title} description={unlock.copy.description} article={unlock.data} error={unlock.isError} showCost={!unlock.isPurchased} />
					<Actions actions={actions} sx={style.actions} />
				</Box.Column>
				{/* {unlock.data?.description && (
					<>
						<Divider />
						<Typography variant="body1" textAlign="center">{unlock.data?.description}</Typography>
					</>
				)} */}
			</Page.Body>
		</Page>
	);
}